import { IGizmo } from '../../types';

interface IParams {
  gizmos: IGizmo[];
}

/**
 * Take a list of gizmo configurations with nested gizmos and flatten it into a single list
 *
 * @param {IGizmo[]} gizmos list of gizmo configurations
 * @returns
 */
function flattenGizmoConfigs({ gizmos }: IParams): IGizmo[] {
  let flattenedGizmoConfigs: IGizmo[] = [];

  gizmos.forEach(function(g) {
    flattenedGizmoConfigs.push(g);

    if (g.gizmos && g.gizmos.length > 0) {
      flattenedGizmoConfigs = flattenedGizmoConfigs.concat(
        flattenGizmoConfigs({ gizmos: g.gizmos })
      );
    }
  });

  return flattenedGizmoConfigs;
}

export default flattenGizmoConfigs;
